<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveMedicine">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Neues Medikament <span class="h6 d-flex mb-0"> {{ medication.grund }} </span></mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body class="example-card scrollbar-blue thin">
            <validation-provider
              name="Medikament"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-select
                outline
                id="Medikament"
                ref="medikament"
                v-model="medikamentOptions"
                label="Medikament"
                name="Medikament"
                search
                @search="handleSearch"
                disableFilter
                placeholder="Medikament"
                validation
              >
                <small slot="footer" class="p-2 grey-text">
                    {{ loading ? "loading..." : medikamentOptions.length === 0 ? searchValue === "" ?
                        "Start typing to load options" : "No results found" : "Select your Medicine" }}
                </small>
              </mdb-select>
            </validation-provider>
            <validation-provider
              name="Dosierung"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                outline
                v-model="form.Dosierung"
                label="Dosierung"
                name="Dosierung"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
              />
            </validation-provider>

            <validation-provider
              name="MaxDosierung"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                outline
                v-model="form.MaxDosierung"
                label="Max. Dosierung"
                name="MaxDosierung"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
              />
            </validation-provider>

            <validation-provider
              name="Priority"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-select
                id="priority"
                ref="priority"
                outline
                v-model="priorityOptions"
                name="Priority"
                label="Priorität"
                validation
              />
              <span v-if="valid" class="valid-feedback d-block">sieht gut aus</span>
              <span v-if="errors[0]" class="invalid-feedback d-block">{{ errors[0] }}</span>
            </validation-provider>

            <validation-provider
              name="Arzt"
              rules="required"
              v-slot="{ errors, valid, validated }"
              slim
            >
              <mdb-input
                outline
                v-model="form.Arzt"
                label="Arzt"
                name="Arzt"
                :customValidation="validated"
                :isValid="valid"
                :invalidFeedback="errors[0]"
                validFeedback="sieht gut aus"
              />
            </validation-provider>
          </mdb-modal-body>
          <mdb-modal-footer>
              <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
              <mdb-btn
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbInput,
    mdbSelect,
    mdbIcon
  } from 'mdbvue';
  import utils from '@/mixins/Utils'

  export default {
    name: 'MedicineModal',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbInput,
      mdbSelect,
      mdbIcon
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      medication: {
        type: Object,
        default: () => {},
      }
    },

    data() {
      return {
        modal: false,
        loading: false,
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        datum: new Date().toISOString().slice(0,10),
        form: {
          Key: '',
          Dosierung: '',
          MaxDosierung: '',
          Prio: null,
          Arzt: '',
          Medikament: '',
          AenderungVon: '',
          AenderungAm: ''
        },
        defaultForm: {
          Key: '',
          Dosierung: '',
          MaxDosierung: '',
          Prio: null,
          Arzt: '',
          Medikament: '',
          AenderungVon: '',
          AenderungAm: ''
        },
        medikamentOptions: [],
        searchValue: "",
      }
    },

    computed: {
      selectedMedicine() {
        const selected = this.medikamentOptions.find(
          option => option.selected
        )
        if (selected === undefined) return ""
        return selected.value
      },

      selectedPriorityOptions() {
        let response = this.priorityOptions.find(option => {
          return option.selected === true
        });
        if (response) {
          return response.value
        }
        return ""
      },
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
      medication (v) {
        this.form.Key = v.id
      }
    },

    methods: {
      save () {
        this.modal = false
        this.$emit('save')
      },

      close () {
        this.$refs.form.reset()
        this.datum = new Date().toISOString().slice(0,10),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.$refs.medikament.inputText = null
        this.$refs.medikament.inputValue = null
        this.$refs.priority.inputText = null
        this.$refs.priority.inputValue = null
        this.medikamentOptions = []
        this.priorityOptions.find(option => {
          option.selected = false
        })
        this.$emit('close')
      },

      handleSearch(value) {
        this.searchValue = value;
        if (value === "" || value.length < 3) {
          this.medikamentOptions = [];
          return;
        }
        this.loading = true;

        this.$http.get(`/Medikamentenblatt/Medikamente/${this.searchValue}`)
          .then(response => {
            if (this.searchValue === "") return;
            const options = response.data.data.map(medicine => {
              return {
                text: medicine.adMedikament_Name, //adMedikament_Wirkstoff
                value: medicine.adMedikament_Id,
                selected: false
              };
            });
            this.medikamentOptions = options;
            this.loading = false;
          })
          .catch(() => {
            this.medikamentOptions = [];
            this.loading = false;
          });
      },

      saveMedicine() {
        this.loading = true

        // select validation check
        this.$refs.medikament.validate()
        if(this.$refs.medikament.inputValue == null || this.$refs.medikament.inputValue == ""){
          this.loading = false
          return
        }

        this.$refs.priority.validate()
        if(this.$refs.priority.inputValue == null || this.$refs.priority.inputValue == ""){
          this.loading = false
          return
        }

        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          var userDate= new Date(this.datum + ' ' + this.uhrzeit)
          this.form.AenderungAm =  this.serverDateFormat(userDate)
          this.form.AenderungVon = this.loginUser.username

          this.form.Key = this.medication.id
          this.form.Medikament = this.selectedMedicine
          this.form.Prio = this.selectedPriorityOptions

          this.$http.post('BedarfsmedikationMedikament', this.form)
            .then(res => {
              if(res.data) {
                this.$notify.success({message: 'Neues Medikament erfolgreich hinzugefügt', position: 'top right', closeButton: false, timeOut: 5000})
                this.close()
                this.save()
              }else {
                this.$notify.error({message: 'Fehler beim Hinzufügen eines neuen Arzneimittels !!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .finally(() => {
              this.loading = false
            })
        });
      }
    }
  }
</script>
